export default (props) => (
  <svg {...props} viewBox="0 0 18 18" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h18v18H0z" />
      <circle fill="currentColor" cx="9" cy="9" r="8" />
      <path
        d="M10.714 6.952l2.837.436a.534.534 0 01.429.372.53.53 0 01-.126.512l-2.08 2.146.481 2.972c.033.2-.05.4-.21.512a.561.561 0 01-.569.033l-2.48-1.38-2.476 1.38a.544.544 0 01-.555-.024.508.508 0 01-.225-.521l.483-2.973-2.076-2.145a.519.519 0 01-.12-.528.528.528 0 01.423-.355l2.834-.437 1.235-2.651a.532.532 0 01.958.003l1.237 2.648z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
